import * as betgalaxy from './QuickAccessMenu.styles.betgalaxy';
import * as betprofessor from './QuickAccessMenu.styles.betprofessor';
import * as betroyale from './QuickAccessMenu.styles.betroyale';
import * as fiestabet from './QuickAccessMenu.styles.fiestabet';
import * as puntcity from './QuickAccessMenu.styles.puntcity';
import * as puntgenie from './QuickAccessMenu.styles.puntgenie';
import * as questbet from './QuickAccessMenu.styles.questbet';
import * as sterlingparker from './QuickAccessMenu.styles.sterlingparker';
import * as vikingbet from './QuickAccessMenu.styles.vikingbet';
import * as volcanobet from './QuickAccessMenu.styles.volcanobet';
import * as wellbet from './QuickAccessMenu.styles.wellbet';
import * as juicybet from './QuickAccessMenu.styles.juicybet';
import * as goldenrush from './QuickAccessMenu.styles.goldenrush';
import * as forsport from './QuickAccessMenu.styles.forsport';
import * as junglebet from './QuickAccessMenu.styles.junglebet';
import * as betstride from './QuickAccessMenu.styles.betstride';
import * as oldgill from './QuickAccessMenu.styles.oldgill';
import * as sugarcastle from './QuickAccessMenu.styles.sugarcastle';
import * as buffalobet from './QuickAccessMenu.styles.buffalobet';
import * as titanbet from './QuickAccessMenu.styles.titanbet';
import * as gigabet from './QuickAccessMenu.styles.gigabet';
import * as slambet from './QuickAccessMenu.styles.slambet';
import * as templebet from './QuickAccessMenu.styles.templebet';
import * as goldenbet888 from './QuickAccessMenu.styles.goldenbet888';
import * as hyperbet from './QuickAccessMenu.styles.hyperbet';
import * as chromabet from './QuickAccessMenu.styles.chromabet';
import * as bet777 from './QuickAccessMenu.styles.bet777';
import * as bet575 from './QuickAccessMenu.styles.bet575';
import * as betblast from './QuickAccessMenu.styles.betblast';
import * as magnumbet from './QuickAccessMenu.styles.magnumbet';
import * as pyramidbet from './QuickAccessMenu.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet777,
  bet575,
  betblast,
  magnumbet,
  pyramidbet,
};
